import React from 'react';

import { ConsentPreferredTime, ConsentPreferredTimeLabels } from '../../../../@types/ConsentPreferredTime';

type ModeFieldKey = 'recallAt' | 'preferredTime' | 'dateRdv' | 'heureRdv';

interface ModeSectionProps {
	scheduleNow: boolean;
	setScheduleNow: (value: boolean) => void;
	fields: Record<ModeFieldKey, string>;
	setField: (key: ModeFieldKey, value: string) => void;
	errors: Record<string, string>;
}

function ModeSection({ scheduleNow, setScheduleNow, fields, setField, errors }: ModeSectionProps) {
	return (
		<>
			<div className="my-4 rounded-lg border border-amber-200 bg-amber-50 p-3">
				<div className="font-semibold text-amber-900"><span role="img" aria-label="calendar">📅</span> Mode de traitement</div>
				<div className="mt-2 flex flex-wrap gap-3">
					<label className="inline-flex items-center gap-2 text-sm">
						<input type="radio" name="traitement" checked={!scheduleNow} onChange={() => setScheduleNow(false)} />
						Recontacter pour planifier le RDV
					</label>
					<label className="inline-flex items-center gap-2 text-sm">
						<input type="radio" name="traitement" checked={scheduleNow} onChange={() => setScheduleNow(true)} />
						Prendre le RDV maintenant
					</label>
				</div>
			</div>

			{!scheduleNow && (
				<>
					<div className="my-4 rounded-lg border border-amber-200 bg-amber-50 p-3">
						<div className="font-semibold text-amber-900"><span role="img" aria-label="alarm clock">⏰</span> Préférences de rappel</div>
						<p className="mt-1 text-sm text-amber-900/80">Indiquez quand recontacter le propriétaire.</p>
					</div>
					<div className="mb-4 grid gap-4 md:grid-cols-2">
						<div>
							<label className="text-sm font-semibold text-slate-700"><span role="img" aria-label="calendar">📅</span> Date de rappel souhaitée *</label>
							<input
								type="date"
								value={fields.recallAt}
								min={new Date().toISOString().split('T')[0]}
								onChange={(e) => setField('recallAt', e.target.value)}
								className="w-full rounded-lg border-2 px-3 py-2"
							/>
							{errors.recallAt && <div className="mt-1 text-xs text-red-600">{errors.recallAt}</div>}
						</div>
						<div>
							<label className="text-sm font-semibold text-slate-700"><span role="img" aria-label="sun">🌤️</span> Moment préféré</label>
							<select
								value={fields.preferredTime}
								onChange={(e) => setField('preferredTime', e.target.value)}
								className="w-full rounded-lg border-2 px-3 py-2"
							>
								<option value={ConsentPreferredTime.MORNING}>{ConsentPreferredTimeLabels[ConsentPreferredTime.MORNING]}</option>
								<option value={ConsentPreferredTime.EVENING}>{ConsentPreferredTimeLabels[ConsentPreferredTime.EVENING]}</option>
								<option value={ConsentPreferredTime.NO_PREFERENCE}>{ConsentPreferredTimeLabels[ConsentPreferredTime.NO_PREFERENCE]}</option>
							</select>
						</div>
					</div>
				</>
			)}

			{scheduleNow && (
				<>
					<div className="my-4 rounded-lg border border-amber-200 bg-amber-50 p-3">
						<div className="font-semibold text-amber-900"><span role="img" aria-label="calendar">📅</span> Programmation du Rendez-vous</div>
					</div>
					<div className="mb-4 grid gap-4 md:grid-cols-2">
						<div>
							<label className="text-sm font-semibold text-slate-700"><span role="img" aria-label="calendar">📅</span> Date du rendez-vous *</label>
							<input type="date" value={fields.dateRdv} onChange={(e) => setField('dateRdv', e.target.value)} className="w-full rounded-lg border-2 px-3 py-2" />
							{errors.dateRdv && <div className="mt-1 text-xs text-red-600">{errors.dateRdv}</div>}
						</div>
						<div>
							<label className="text-sm font-semibold text-slate-700">⏰ Heure du rendez-vous *</label>
							<input type="time" value={fields.heureRdv} onChange={(e) => setField('heureRdv', e.target.value)} className="w-full rounded-lg border-2 px-3 py-2" />
							{errors.heureRdv && <div className="mt-1 text-xs text-red-600">{errors.heureRdv}</div>}
						</div>
					</div>
				</>
			)}
		</>
	);
}

export default ModeSection;


